import React from 'react'

const MediaKitContext = React.createContext()

export default MediaKitContext
